module.exports = __webpack_public_path__ + "fonts/LatoLatin-Semibold.b8c03b8.woff2";